import { useEffect, useState } from "react";
import SlideoutMenu from "@components/SlideOutMenuV2/SlideOutMenu";
import { QuestionForm } from "./QuestionForm";
import type { QuestionFormValues } from "./types";

export interface QuestionSlideoutProps {
  isOpen: boolean;
  mode: "create" | "edit";
  initialValues: QuestionFormValues;
  slug: string;
  onClose: () => void;
  onSave: (values: QuestionFormValues) => Promise<unknown>;
}

const isValid = (v: QuestionFormValues): boolean =>
  v.question.trim() !== "" &&
  v.name.trim() !== "" &&
  v.selectOptions.every((o) => o.key.trim() === "" || o.value.trim() !== "");

export const QuestionSlideout = ({
  isOpen,
  mode,
  initialValues,
  slug,
  onClose,
  onSave,
}: QuestionSlideoutProps): JSX.Element => {
  const [values, setValues] = useState<QuestionFormValues>(initialValues);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (isOpen) setValues(initialValues);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, initialValues]);

  const handleSave = async () => {
    if (!isValid(values) || saving) return;
    setSaving(true);
    try {
      await onSave(values);
    } finally {
      setSaving(false);
    }
  };

  return (
    <SlideoutMenu
      isOpen={isOpen}
      onClose={onClose}
      onSave={handleSave}
      title={mode === "create" ? "Add Question" : "Edit Question"}
      actionBtnDisabled={saving || !isValid(values)}
    >
      {isOpen && (
        <QuestionForm
          values={values}
          onChange={setValues}
          mode={mode}
          slug={slug}
        />
      )}
    </SlideoutMenu>
  );
};

export default QuestionSlideout;
